import { IServices } from 'services/services';
import { LayoutHOC } from 'base/ui/layout/layout';
import createChangeAfter90DaysPassword from './changePasswordAfter90Days';
import { createChangePasswordAfter90DaysPage } from './changePasswordAfter90Days/create';
import { createChangePasswordPage } from './changePassword/create';
import { createConnectMSPage } from './ConnectMS/create';
import { createHomePage } from './dashboard/create';
import { createIconPage } from './iconScreen/create';
import { createLoginPage } from './login/create';
import { createMasterDataPage } from './rawData/MasterData/create';
import { createModulePage } from './module/create';
import { createPermissionPage } from './rawData/Permission/create';
import { createPrintPDFPage } from './vehicleRegistration/PrintPDF/create';
import { createPurchaseOrderPage } from './purchaseOrder/create';
import { createReceiveSchedulePage } from './receiveSchedule/create';
import { createReportPage } from './report/create';
import { createSynchPurchaseOrderPage } from './synchPO/create';
import { createVehicleRegistrationPage } from './vehicleRegistration/create';
import { createWasteHandoverPlanPage } from './wasteHandoverPlan/create';
import { createWasteHandoverRegistrationPage } from './wasteHandoverRegistration/create';
import { createWasteHandoverRegistrationPrintPDFPage } from './wasteHandoverRegistration/PrintPDF/create';
import { createVerifyPage } from './login/QRCodeVerify/create';
import { createViewHistoryLogInPage } from './history/create';
import { createReceiveSchedule2Page } from './receiveSchedule2/create';
import { createReceiveSchedule3Page } from './receiveSchedule3/create';

export function createPages(layoutHOC: LayoutHOC, services: IServices) {
  return {
    // ======== PAGE HỆ THỐNG =================================================
    HomePage: createHomePage(layoutHOC),
    LoginPage: createLoginPage(layoutHOC, services.userServices),
    // trang modules
    ModulePage: createModulePage(layoutHOC),
    // Xem icons
    IconsPage: createIconPage(layoutHOC),
    // Xác thực khi đăng nhập (quét QR Code)
    VerifyPage: createVerifyPage(layoutHOC),
    // đổi mật khẩu
    ChangePasswordPage: createChangePasswordPage(layoutHOC, services.accountServices),
    //đổi mật khẩu sau 90 ngày
    ChangePasswordPageAfter90Days: createChangePasswordAfter90DaysPage(services.accountServices),
    // kết nối Microsoft
    ConnectMSPage: createConnectMSPage(layoutHOC),
    LogInHistoryPage: createViewHistoryLogInPage(layoutHOC),
    // ========================================================================

    //========= PAGE DỰ ÁN ==================================================
    // Danh sách po
    PurchaseOrderPage: createPurchaseOrderPage(layoutHOC, services),
    // Đăng ký giao hàng
    VehicleRegistrationPage: createVehicleRegistrationPage(layoutHOC),
    // Đồng bộ PO
    SynchPOPage: createSynchPurchaseOrderPage(layoutHOC),
    // BÁO CÁO
    ReportPage: createReportPage(layoutHOC),
    // Lịch nhận hàng
    ReceiveSchedulePage: createReceiveSchedulePage(layoutHOC, services.purchaseOrderServices),

    // Lịch nhận hàng 2 (phiên bản mới với giao diện Kanban)
    ReceiveSchedule2Page: createReceiveSchedule2Page(layoutHOC, services.purchaseOrderServices),

    //
    ReceiveSchedule3Page: createReceiveSchedule3Page(layoutHOC, services.purchaseOrderServices),

    // Kế hoạch bàn giao chất thải/phế liệu
    WasteHandoverPlanPage: createWasteHandoverPlanPage(layoutHOC, services),
    // Đăng ký bàn giao chất thải/phế liệu
    WasteHandoverRegistrationPage: createWasteHandoverRegistrationPage(layoutHOC),
    WasteHandoverRegistrationPrintPDFPage: createWasteHandoverRegistrationPrintPDFPage(layoutHOC),

    PrintPDFPage: createPrintPDFPage(layoutHOC),
    // ======================================================================

    //  ========= PAGE DÙNG CHUNG ============================================
    // Master data
    MasterData: createMasterDataPage(layoutHOC),
    // Permission
    Permission: createPermissionPage(layoutHOC, services),
    // =======================================================================
  };
}
